import { useState, useCallback } from 'react';
import { Node } from '../types/cytoscape';
import { NodeTooltipProps } from '../components/tooltips/NodeTooltip';
/**
 * ノードのツールチップを管理するカスタムフック
 */
export const useNodeTooltip = () => {
  // ツールチップの状態管理
  const [tooltipState, setTooltipState] = useState<NodeTooltipProps>({
    content: null,
    position: { x: 0, y: 0 },
    visible: false,
  });

  // ツールチップ表示のためのアクション
  const showTooltip = useCallback(
    (nodeData: Node, position: { x: number; y: number }) => {
      const content: NodeTooltipProps = {
        content: nodeData,
        position: { x: Math.round(position.x), y: Math.round(position.y) },
        visible: true,
      };

      setTooltipState(content);
    },
    []
  );

  // ツールチップ非表示のアクション
  const hideTooltip = useCallback(() => {
    setTooltipState((prev: NodeTooltipProps) => ({ ...prev, visible: false }));
  }, []);

  return {
    tooltipState,
    showTooltip,
    hideTooltip,
  };
};
